import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as debug from 'debug';
import * as moment from 'moment';
import { ConfigProvider } from '../config/config';
import { SettingsProvider } from '../settings/settings';
import { UserProvider } from '../user/user';
import { CrudApiProvider } from '../crud-api/crud-api';
import { UiToolsProvider } from '../ui-tools/ui-tools';
import { ToolsProvider } from '../tools/tools';
import { AlertController } from 'ionic-angular';

declare let CmKit: any;

/*
  Generated class for the ContentToolsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ContentToolsProvider {
  log = debug('app:ContentToolsProvider');

  // passed in user provider (circular deps)
  user;
  tools;

  whitelistSensitiveContent = {};

  constructor(
    public http: HttpClient,
    public config: ConfigProvider,
    public settings: SettingsProvider,
    public crudApi: CrudApiProvider,
    public uiTools: UiToolsProvider,
    public alertCtrl: AlertController
  ) {}

  whiteListSensitive(content) {
    this.whiteListSensitive[content && content._id] = true;
  }

  getCategoryForContent(content) {
    let cat, key;
    const cats = ['SEX', 'VIOLENCE', 'POLITICS', 'OTHER_CONTROVERSIAL'];
    _.each(cats, cat => {
      key = _.find(content && content.dimensions, d => {
        if (/CATEGORY_/i.test(d)) {
          let replacedCat = d.replace(/CATEGORY_/, '');
          return replacedCat === cat;
        }
      });
      if (key) return false;
    });

    if (key) {
      key = key.replace(/CATEGORY_/, '');
    }

    if (!key) {
      cat = {
        key: 'OTHER',
        title: '',
      };
    } else {
      cat = _.find(this.config.get('contentCategories'), d => {
        return d.key === key;
      });
    }

    return cat;
  }

  getCategoryForContentMulti(content) {
    let matches = [];
    let contentDimensions = _.get(content, 'dimensions', []);
    let contentCategoryDimensions = _.map(
      _.filter(contentDimensions, cd => {
        if (/CATEGORY_/i.test(cd)) {
          return true;
        } else {
          return false;
        }
      }),
      d => d.replace(/CATEGORY_/, '')
    );

    matches = _.intersection(contentCategoryDimensions, [
      'SEX',
      'VIOLENCE',
      'POLITICS',
      'OTHER_CONTROVERSIAL',
    ]);

    if (!_.size(matches)) {
      matches = [
        {
          key: 'OTHER',
          title: '',
        },
      ];
    } else {
      // convert back to array of objects
      matches = _.map(matches, m => {
        return _.find(this.config.get('contentCategories'), d => {
          return d.key === m;
        });
      });
    }

    return matches;
  }

  formattedContentCategories(content) {
    return _.map(this.getCategoryForContentMulti(content), 'title').join(', ');
  }

  async selectCategory(question, opts?, currentSelection?) {
    let categories = this.config.get('contentCategories');
    let buttons = [];
    let icon = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8C15.75 3.71875 12.2812 0.25 8 0.25ZM14.75 8C14.75 11.7188 11.7188 14.75 8 14.75C4.28125 14.75 1.25 11.75 1.25 8C1.25 4.3125 4.25 1.25 8 1.25C11.6875 1.25 14.75 4.28125 14.75 8Z" fill="#262626"/>
      </svg>
    `;
    let activeIcon = `
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7" cy="7" r="6.5" stroke="#2E5FF6"/>
        <circle cx="7" cy="7" r="3.5" fill="#2E5FF6" stroke="#2E5FF6"/>
      </svg>
    `;

    // Just in case there are still non-objects being sent in as currentSelection
    const checkCurrent = key => {
      if (typeof currentSelection === 'object') {
        return _.some(currentSelection, current => {
          return current.key === key;
        });
      } else {
        return currentSelection === key;
      }
    };

    if (opts && opts.type) {
      categories = _.filter(categories, { type: opts.type });
    }

    buttons = categories.map(c => {
      return {
        key: c.key,
        text: c.title,
        icon: checkCurrent(c.key) ? activeIcon : icon,
      };
    });

    buttons.push({
      key: 'NONE',
      text: 'None',
      icon:
        _.isEmpty(currentSelection) || checkCurrent('OTHER')
          ? activeIcon
          : icon,
    });

    buttons = _.filter(buttons, b => {
      return !_.includes(_.get(opts, 'hide', []), b.key);
    });

    return await CmKit.ActionSheet({
      props: {
        title: question,
        buttons,
      },
    }).promise;
  }

  contentIsWhitelisted(content) {
    if (this.whiteListSensitive[content && content._id]) {
      return true;
    }

    // if content and post etc
    if (this.whiteListSensitive[content && content.post]) {
      return true;
    }
  }

  getVisibilitySettingForContent(content): 'ASK' | 'HIDE' | 'SHOW' {
    if (this.contentIsWhitelisted(content)) return 'SHOW';

    const categories = this.getCategoryForContentMulti(content);
    const settings = this.settings.get(
      'feedContent',
      this.settings.defaultFeedContentSettings
    );
    const isSensitive = _.get(content, 'states.isSensitive');
    let rules = [];

    _.each(categories, c => {
      const rule = _.get(settings, _.get(c, 'key')) || 'ASK_SENSITIVE';

      if (rule === 'SHOW') {
        rules.push('SHOW');
      } else if (rule === 'HIDE') {
        rules.push('HIDE');
      } else if (rule === 'ASK_SENSITIVE') {
        if (isSensitive) return rules.push('ASK');
        else return rules.push('SHOW');
      } else if (rule === 'NO_SENSITIVE') {
        if (isSensitive) return rules.push('HIDE');
        else return rules.push('SHOW');
      }
    });

    rules = _.sortBy(_.uniq(rules), r => {
      const rank = {
        SHOW: 3,
        ASK: 2,
        HIDE: 1,
      };

      return rank[r] || 10;
    });

    return _.first(rules);
  }

  async actionSheet(content, collection: 'posts' | 'engagements', opts) {
    if (
      !this.user.userPermission(collection === 'posts' ? 'post' : 'comment')
    ) {
      return this.tools.loginBlock('You must be logged in.');
    }

    const title = {
      posts: 'Post',
      engagements: 'Comment',
    }[collection];

    opts = _.merge(opts, {
      userEngagements: {},

      // optional listeners
    });

    // default listeners
    _.each(
      {
        navCtrl: {
          // stubbed - needs to be passed in
          push: () => {},
        },
        onURM: () => {},
        onEdit: () => {},
        onDelete: () => {},
        onPin: () => {},
        onEngagement: () => {},
        onCategorize: () => {},
        onReport: () => {},
        onBlockUser: () => {},
      },
      (fn, k) => {
        if (!opts[k]) opts[k] = fn;
      }
    );

    let buttons = [];

    if (this.user.isAdmin()) {
      buttons.push({
        sectionTitle: 'Admin Options',
      });
      if (collection === 'posts' && content.source === 'COMMUNITY') {
        buttons.push({
          icon: `
          <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.375 6.375L9.0625 4H10.25C10.6562 4 11 3.6875 11 3.25V0.75C11 0.34375 10.6562 0 10.25 0H1.75C1.3125 0 1 0.34375 1 0.75V3.25C1 3.6875 1.3125 4 1.75 4H2.90625L2.59375 6.375C1.0625 7.25 0 8.71875 0 10.5C0 10.75 0.21875 11 0.5 11H5.5V14.75C5.5 14.7812 5.5 14.8125 5.5 14.8125L5.75 15.8125C5.8125 16.0625 6.15625 16.0625 6.21875 15.8125L6.46875 14.8125C6.46875 14.8125 6.46875 14.7812 6.46875 14.75V11H11.4688C11.75 11 11.9688 10.75 11.9688 10.5C12 8.71875 10.9062 7.25 9.375 6.375ZM1.03125 10C1.25 8.65625 2.25 7.59375 3.5 7.03125L4 3H2V1H10V3H8L8.46875 7.03125C9.71875 7.59375 10.75 8.65625 10.9375 10H1.03125Z" fill="#262626"/>
          </svg>
          `,
          text: _.get(content, 'states.isPinned')
            ? 'Unpin Content'
            : 'Save as Pinned Post',
          handler: () => {
            opts.onPin();
          },
        });
        buttons.push({
          icon: `
          <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.375 6.375L9.0625 4H10.25C10.6562 4 11 3.6875 11 3.25V0.75C11 0.34375 10.6562 0 10.25 0H1.75C1.3125 0 1 0.34375 1 0.75V3.25C1 3.6875 1.3125 4 1.75 4H2.90625L2.59375 6.375C1.0625 7.25 0 8.71875 0 10.5C0 10.75 0.21875 11 0.5 11H5.5V14.75C5.5 14.7812 5.5 14.8125 5.5 14.8125L5.75 15.8125C5.8125 16.0625 6.15625 16.0625 6.21875 15.8125L6.46875 14.8125C6.46875 14.8125 6.46875 14.7812 6.46875 14.75V11H11.4688C11.75 11 11.9688 10.75 11.9688 10.5C12 8.71875 10.9062 7.25 9.375 6.375ZM1.03125 10C1.25 8.65625 2.25 7.59375 3.5 7.03125L4 3H2V1H10V3H8L8.46875 7.03125C9.71875 7.59375 10.75 8.65625 10.9375 10H1.03125Z" fill="#262626"/>
          </svg>
          `,
          text: _.get(content, 'states.urmSendApproved')
            ? 'Unmark for URM Sends'
            : 'Approved for URM Sends',
          handler: () => {
            opts.onURM();
          },
        });
      }

      buttons.push({
        icon: `
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5312 7.0625L8.9375 0.46875C8.6875 0.21875 8.21875 0 7.875 0H1.5C0.65625 0 0 0.6875 0 1.5V7.90625C0 8.25 0.1875 8.71875 0.4375 8.96875L7.03125 15.5625C7.625 16.1562 8.59375 16.1562 9.15625 15.5625L15.5312 9.1875C16.125 8.625 16.125 7.65625 15.5312 7.0625ZM14.8438 8.5L8.46875 14.875C8.25 15.0625 7.9375 15.0625 7.75 14.875L1.125 8.25C1.0625 8.15625 1 8 1 7.90625V1.5C1 1.25 1.21875 1 1.5 1H7.875C8 1 8.125 1.0625 8.21875 1.15625L14.8438 7.78125C15.0312 7.96875 15.0312 8.28125 14.8438 8.5ZM4.5 3.875C4.84375 3.875 5.125 4.15625 5.125 4.5C5.125 4.875 4.84375 5.125 4.5 5.125C4.125 5.125 3.875 4.875 3.875 4.5C3.875 4.15625 4.125 3.875 4.5 3.875ZM4.5 3C3.65625 3 3 3.6875 3 4.5C3 5.34375 3.65625 6 4.5 6C5.3125 6 6 5.34375 6 4.5C6 3.6875 5.3125 3 4.5 3Z" fill="#262626"/>
          </svg>
          `,
        text: 'Set Controversial Category',
        subText: this.formattedContentCategories(content),
        handler: async () => {
          const choice = await this.selectCategory(
            'Set Controversial Category',
            {
              type: 'controversial',
            },
            this.getCategoryForContentMulti(content)
          );

          // check if empty
          if (!choice) return;

          // remove dimension if already exists
          let updatedDimensions = _.remove(content.dimensions, d => {
            return d === 'CATEGORY_' + choice.key;
          });

          // if we haven't removed one, we either need to add one or remove all categories
          if (!_.size(updatedDimensions)) {
            if (choice.key === 'NONE') {
              content.dimensions = content.dimensions.filter(d => {
                return !/CATEGORY_/.test(d);
              });
            } else {
              content.dimensions.push('CATEGORY_' + choice.key);
            }
          }

          try {
            await this.crudApi
              .post(`/api/${collection}/${content._id}/dimensions`, {
                value: 'CATEGORY_' + choice.key,
              })
              .then(response => {
                opts.onCategorize(content.dimensions);
              });
          } catch (e) {}
        },
      });

      buttons.push({
        icon: `
          <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.63797 5.31443C7.11344 5.31443 6.60068 5.15889 6.16455 4.86747C5.72842 4.57606 5.38849 4.16186 5.18776 3.67725C4.98703 3.19265 4.93451 2.6594 5.03684 2.14495C5.13917 1.63049 5.39176 1.15793 5.76266 0.787034C6.13356 0.416133 6.60612 0.163546 7.12058 0.0612142C7.63503 -0.0411172 8.16828 0.011403 8.65289 0.212133C9.13749 0.412864 9.55169 0.752788 9.84311 1.18892C10.1345 1.62506 10.2901 2.13781 10.2901 2.66234C10.2892 3.36546 10.0095 4.03953 9.51235 4.53671C9.01517 5.03389 8.34109 5.31358 7.63797 5.31443ZM7.63797 0.767995C7.26331 0.767995 6.89705 0.879096 6.58553 1.08725C6.274 1.2954 6.0312 1.59126 5.88782 1.93741C5.74444 2.28355 5.70693 2.66444 5.78002 3.03191C5.85312 3.39938 6.03354 3.73692 6.29847 4.00185C6.5634 4.26678 6.90094 4.4472 7.2684 4.52029C7.63587 4.59339 8.01676 4.55587 8.36291 4.41249C8.70906 4.26911 9.00492 4.02631 9.21307 3.71479C9.42122 3.40326 9.53233 3.03701 9.53233 2.66234C9.53174 2.16011 9.33196 1.67862 8.97683 1.32349C8.6217 0.968359 8.14021 0.768586 7.63797 0.767995Z" fill="#262626"/>
          <path d="M15.1195 2.24281C15.0484 2.17178 14.9521 2.13187 14.8516 2.13187C14.7511 2.13187 14.6548 2.17178 14.5837 2.24281L0.156324 16.6702C0.120265 16.7052 0.0915231 16.747 0.071771 16.7932C0.0520189 16.8394 0.0416509 16.889 0.0412706 16.9393C0.0408904 16.9895 0.0505055 17.0393 0.0695561 17.0858C0.0886067 17.1323 0.116712 17.1745 0.152238 17.21C0.187763 17.2456 0.229999 17.2737 0.276487 17.2927C0.322975 17.3118 0.372787 17.3214 0.423025 17.321C0.473262 17.3206 0.522921 17.3102 0.569113 17.2905C0.615305 17.2707 0.657106 17.242 0.692085 17.2059L1.9641 15.9339L1.9652 15.9331C2.9309 14.9679 5.13752 14.4436 7.86421 14.532C10.3257 14.6116 12.5649 15.1876 13.3105 15.9331C13.3819 16.0022 13.4776 16.0403 13.577 16.0395C13.6763 16.0386 13.7713 15.9988 13.8416 15.9285C13.9118 15.8583 13.9517 15.7633 13.9525 15.6639C13.9534 15.5646 13.9152 15.4689 13.8462 15.3974C12.8254 14.3762 10.1186 13.8468 7.88861 13.775C6.4787 13.7145 5.06743 13.8575 3.69831 14.1996L15.1195 2.77854C15.1905 2.70749 15.2304 2.61114 15.2304 2.51068C15.2304 2.41021 15.1905 2.31386 15.1195 2.24281Z" fill="#262626"/>
          <path d="M11.0327 21.9847C10.999 21.9849 10.9654 21.9804 10.9328 21.9714C10.8359 21.945 10.7534 21.8812 10.7035 21.794C10.6536 21.7067 10.6404 21.6033 10.6668 21.5063L11.9398 16.8386C11.9662 16.7417 12.03 16.6592 12.1172 16.6093C12.2045 16.5594 12.308 16.5462 12.4049 16.5726C12.5019 16.599 12.5844 16.6628 12.6343 16.75C12.6842 16.8373 12.6974 16.9407 12.671 17.0377L11.398 21.7054C11.3762 21.7856 11.3286 21.8563 11.2626 21.9068C11.1966 21.9573 11.1158 21.9847 11.0327 21.9847Z" fill="#262626"/>
          <path d="M4.24262 21.9848C4.15954 21.9847 4.07879 21.9574 4.01281 21.9069C3.94682 21.8564 3.89925 21.7856 3.87743 21.7055L2.60442 17.0378C2.59135 16.9898 2.58787 16.9397 2.59417 16.8903C2.60046 16.841 2.61642 16.7933 2.64113 16.7501C2.66584 16.7069 2.69881 16.669 2.73817 16.6386C2.77752 16.6081 2.82249 16.5857 2.8705 16.5727C2.91852 16.5596 2.96863 16.5561 3.01799 16.5624C3.06735 16.5687 3.11499 16.5847 3.15818 16.6094C3.20137 16.6341 3.23927 16.6671 3.26972 16.7064C3.30017 16.7458 3.32257 16.7907 3.33564 16.8387L4.60864 21.5064C4.63503 21.6034 4.62183 21.7068 4.57194 21.7941C4.52204 21.8813 4.43955 21.9451 4.3426 21.9715C4.31004 21.9805 4.2764 21.985 4.24262 21.9848Z" fill="#262626"/>
          <path d="M8.91137 21.9846C8.88627 21.9846 8.86124 21.9821 8.83665 21.9771C8.73813 21.9573 8.65148 21.8993 8.59576 21.8157C8.54004 21.732 8.51982 21.6297 8.53954 21.5312L9.2958 17.7492C9.3075 17.6908 9.30088 17.6303 9.27683 17.5758C9.25279 17.5214 9.2125 17.4757 9.16149 17.445C8.70151 17.1683 8.17486 17.0221 7.63806 17.0221C7.10127 17.0221 6.57461 17.1683 6.11463 17.445C6.06351 17.4756 6.02312 17.5213 5.999 17.5757C5.97488 17.6302 5.96823 17.6908 5.97994 17.7492L6.73616 21.5314C6.74668 21.5805 6.74735 21.6311 6.73812 21.6805C6.72889 21.7298 6.70996 21.7768 6.68241 21.8188C6.65486 21.8607 6.61926 21.8968 6.57766 21.9248C6.53606 21.9529 6.4893 21.9724 6.44009 21.9823C6.39088 21.9922 6.3402 21.9921 6.291 21.9822C6.2418 21.9723 6.19506 21.9528 6.15348 21.9247C6.11191 21.8965 6.07633 21.8604 6.04883 21.8185C6.02132 21.7765 6.00242 21.7295 5.99324 21.6801L5.23698 17.8981C5.19479 17.6864 5.21904 17.4669 5.30639 17.2696C5.39375 17.0722 5.53996 16.9067 5.725 16.7956C6.3026 16.4481 6.96395 16.2645 7.63802 16.2645C8.3121 16.2645 8.97345 16.4481 9.55105 16.7956C9.73599 16.9067 9.88208 17.0723 9.96937 17.2697C10.0567 17.467 10.0809 17.6865 10.0387 17.8981L9.28243 21.6801C9.26525 21.7659 9.21891 21.8431 9.15127 21.8986C9.08363 21.9541 8.99886 21.9845 8.91137 21.9846Z" fill="#262626"/>
          <path d="M3.01395 12.3594C2.994 12.3594 2.97408 12.3578 2.95439 12.3546C2.90524 12.3469 2.85809 12.3296 2.81564 12.3036C2.77319 12.2777 2.73629 12.2436 2.70704 12.2033C2.67779 12.1631 2.65676 12.1175 2.64518 12.0691C2.63359 12.0207 2.63166 11.9705 2.63951 11.9214L3.13272 8.80344C3.25015 8.04079 3.63742 7.34563 4.22408 6.84439C4.81074 6.34315 5.55782 6.06912 6.32944 6.07216H8.77433C8.87481 6.07216 8.97118 6.11207 9.04223 6.18312C9.11328 6.25418 9.1532 6.35054 9.1532 6.45103C9.1532 6.55151 9.11328 6.64788 9.04223 6.71893C8.97118 6.78998 8.87481 6.8299 8.77433 6.8299H6.32944C5.73845 6.82766 5.16627 7.03756 4.71692 7.42146C4.26758 7.80535 3.97091 8.33774 3.88084 8.92183L3.38763 12.0398C3.37354 12.1288 3.32818 12.2099 3.25969 12.2684C3.19121 12.327 3.10408 12.3593 3.01395 12.3594Z" fill="#262626"/>
          <path d="M12.4932 13.6989C12.403 13.6988 12.3159 13.6666 12.2474 13.608C12.1789 13.5494 12.1335 13.4683 12.1194 13.3792L11.395 8.80058C11.3602 8.58256 11.2961 8.37024 11.2045 8.16938C11.1827 8.12393 11.1701 8.07459 11.1676 8.02425C11.1651 7.9739 11.1727 7.92356 11.1899 7.87618C11.2071 7.82879 11.2336 7.78531 11.2678 7.74829C11.302 7.71127 11.3432 7.68144 11.3891 7.66056C11.435 7.63968 11.4846 7.62817 11.535 7.6267C11.5853 7.62523 11.6355 7.63382 11.6825 7.65199C11.7296 7.67015 11.7725 7.69751 11.8088 7.73248C11.8451 7.76744 11.8741 7.8093 11.894 7.8556C12.0141 8.11857 12.0978 8.39664 12.143 8.68218L12.8674 13.2608C12.8753 13.3099 12.8734 13.3601 12.8618 13.4085C12.8502 13.4569 12.8292 13.5025 12.7999 13.5428C12.7707 13.583 12.7338 13.6171 12.6913 13.6431C12.6489 13.669 12.6018 13.6864 12.5526 13.6941C12.533 13.6973 12.5131 13.6989 12.4932 13.6989Z" fill="#262626"/>
          </svg>
          `,
        text: _.get(content, 'states.isSensitive')
          ? 'Unmark as Sensitive Content'
          : 'Mark as Sensitive Content',
        handler: async () => {
          const val = !_.get(content, 'states.isSensitive');
          _.set(content, 'states.isSensitive', val);
          await this.crudApi.put(`/api/${collection}/${content._id}`, {
            states: {
              isSensitive: val,
            },
          });
        },
      });

      buttons.push({
        icon: `
          <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.9062 15.1875L0.71875 0.0625C0.65625 0.03125 0.59375 0 0.5625 0C0.46875 0 0.40625 0.0625 0.34375 0.09375L0.03125 0.5C0 0.53125 0 0.59375 0 0.65625C0 0.71875 0.03125 0.8125 0.09375 0.84375L19.2812 15.9688C19.3125 16 19.375 16.0312 19.4375 16.0312C19.5 16.0312 19.5625 15.9688 19.625 15.9062L19.9375 15.5312C19.9688 15.5 20 15.4375 20 15.375C20 15.3125 19.9375 15.2188 19.9062 15.1875ZM10 3C12.1875 3.03125 13.9688 4.8125 14 7C14 7.6875 13.8125 8.3125 13.5 8.875L14.3125 9.5C14.7188 8.78125 15 7.9375 15 7C15 5.875 14.5938 4.8125 13.9375 3.96875C15.4062 4.71875 17.2188 6.53125 18 8C17.5312 8.875 16.5938 10.0938 15.875 10.75L16.6562 11.375C17.5625 10.5312 18.3125 9.5625 18.875 8.46875C18.9375 8.34375 19 8.15625 19 8C19 7.875 18.9375 7.6875 18.875 7.5625C17.1875 4.25 13.8125 2 10 2H9.96875C8.8125 2 7 2.40625 5.90625 2.90625L7.34375 4.03125C8.0625 3.40625 8.96875 3 10 3ZM11.875 7.59375C11.9375 7.4375 12 7.15625 12 7C12 5.90625 11.0938 5 10 5C9.96875 5 9.9375 5.03125 9.90625 5.03125C9.9375 5.15625 10 5.375 10 5.53125C10 5.65625 9.9375 5.90625 9.875 6.03125L11.875 7.59375ZM5.09375 6.0625C5.03125 6.3125 5 6.75 5 7C4.96875 7.03125 4.96875 7.03125 4.96875 7.03125C4.96875 9.78125 7.21875 12.0312 9.96875 12.0312C10.5625 12.0312 11.5 11.8125 12.0625 11.5625L11.125 10.8125C10.75 10.9375 10.375 11 10 11C7.78125 11 6 9.21875 6 7C6 6.9375 6 6.875 6 6.78125L5.09375 6.0625ZM10 13C6.625 13 3.5625 11.0938 2 8C2.53125 6.9375 3.28125 6.0625 4.125 5.3125L3.3125 4.65625C2.40625 5.5 1.65625 6.46875 1.09375 7.5625C1.03125 7.6875 1 7.875 1 8.03125C1 8.15625 1.03125 8.34375 1.09375 8.46875C2.78125 11.7812 6.15625 14 10 14C11.1562 14 12.9688 13.625 14.0625 13.125L13.125 12.4062C12.1562 12.7812 11.0938 13 10 13Z" fill="#262626"/>
          </svg>
          `,
        text: _.get(content, 'states.isBanned')
          ? `Unhide ${title} from Users`
          : `Hide ${title} from Users`,
        handler: async () => {
          const val = !_.get(content, 'states.isBanned');
          _.set(content, 'states.isBanned', val);

          // only modify sensitivity if banning
          const states = val
            ? {
                isBanned: val,
                isSensitive: val,
              }
            : { isBanned: val };

          if (val) {
            _.set(content, 'states.isSensitive', val);
          }
          await this.crudApi.put(`/api/${collection}/${content._id}`, {
            states: states,
          });
        },
      });

      buttons.push({
        icon: `
          <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.75 2H10.5L9.4375 0.625C9.1875 0.28125 8.65625 0 8.25 0H5.75C5.3125 0 4.78125 0.28125 4.53125 0.625L3.5 2H0.25C0.09375 2 0 2.125 0 2.25V2.75C0 2.90625 0.09375 3 0.25 3H0.8125L1.875 14.6562C1.9375 15.4062 2.59375 16 3.34375 16H10.625C11.375 16 12.0312 15.4062 12.0938 14.6562L13.1562 3H13.75C13.875 3 14 2.90625 14 2.75V2.25C14 2.125 13.875 2 13.75 2ZM5.34375 1.21875C5.40625 1.09375 5.59375 1.03125 5.75 1H8.25C8.375 1.03125 8.5625 1.09375 8.625 1.21875L9.25 2H4.75L5.34375 1.21875ZM11.125 14.5625C11.0938 14.8125 10.875 15 10.625 15H3.34375C3.09375 15 2.875 14.8125 2.875 14.5625L1.84375 3H12.1562L11.125 14.5625Z" fill="#262626"/>
          </svg>
          `,
        text: `Permanently Delete ${title}`,
        handler: async () => {
          this.actionDelete(content, collection, opts);
        },
      });

      buttons.push({
        icon: '<i class="far fa-hashtag"></i>',
        text: `Delete Tag from ${title}`,
        handler: async () => {
          this.actionRemoveTag(content, collection, opts);
        },
      });
    }

    if (this.user.isContentModerator()) {
      if (content.user && content.user._id && content.postType !== 'ARTICLE') {
        buttons.push({
          sectionTitle: 'Moderator Options',
        });
        buttons.push({
          text: 'Escalate to CDLLife',
          icon: `
          <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16 10H15.9375L15.1875 4.21875C15.0312 3 13.9375 2.03125 12.7188 2H7.25C6.03125 2.03125 4.9375 3 4.78125 4.21875L4.03125 10H4C3.4375 10 3 10.4688 3 11V13C3 13.5625 3.4375 14 4 14H16C16.5312 14 17 13.5625 17 13V11C17 10.4688 16.5312 10 16 10ZM5.75 4.3125C5.84375 3.59375 6.53125 3.03125 7.25 3H12.7188C13.4375 3.03125 14.125 3.59375 14.2188 4.3125L14.9062 10H7.21875L7.96875 4.375C7.96875 4.34375 8 4.34375 8 4.34375C8 4.21875 7.875 4.09375 7.78125 4.09375L7.28125 4.03125C7.25 4 7.25 4 7.25 4C7.125 4 7 4.125 7 4.21875L6.21875 10H5.0625L5.75 4.3125ZM16 13H4V11H16V13ZM2.5 5H0.5C0.21875 5 0 5.25 0 5.5C0 5.78125 0.21875 6 0.5 6H2.5C2.75 6 3 5.78125 3 5.5C3 5.25 2.75 5 2.5 5ZM19.5 5H17.5C17.2188 5 17 5.25 17 5.5C17 5.78125 17.2188 6 17.5 6H19.5C19.75 6 20 5.78125 20 5.5C20 5.25 19.75 5 19.5 5ZM1.25 0.96875L3.25 1.96875C3.3125 2 3.40625 2 3.5 2C3.75 2 4 1.78125 4 1.5C4 1.34375 3.875 1.15625 3.71875 1.0625L1.71875 0.0625C1.65625 0.03125 1.5625 0 1.5 0C1.21875 0 0.96875 0.25 0.96875 0.5C0.96875 0.6875 1.09375 0.875 1.25 0.96875ZM16.5 2C16.5625 2 16.6562 2 16.7188 1.96875L18.7188 0.96875C18.875 0.875 19 0.6875 19 0.5C19 0.25 18.75 0 18.5 0C18.4062 0 18.3125 0.03125 18.25 0.0625L16.25 1.0625C16.0938 1.15625 15.9688 1.34375 15.9688 1.5C15.9688 1.78125 16.2188 2 16.4688 2H16.5Z" fill="#262626"/>
          </svg>
          `,
          handler: () => {
            this.log('will excalate');
            this.actionReportContent(content, collection, opts);
          },
        });
      }

      buttons.push({
        sectionTitle: ' ',
      });
    }

    if (content.user && content.user._id && content.postType !== 'ARTICLE') {
      let postCreator = this.uiTools.usersName(content.user);
      if (content.source === 'COMMUNITY' || collection === 'engagements') {
        buttons.push(
          _.get(content, 'user._id') !== this.user.get('_id')
            ? {
                icon: `<i class="far fa-fw fa-user-slash"></i>`,
                text:
                  content.user.firstName === undefined ||
                  _.size(postCreator) > 20
                    ? 'Block User'
                    : 'Block ' + postCreator,
                subText:
                  "You won't be able to communicate or see each other's posts.",
                handler: async event => {
                  const postUser = _.get(content, 'user._id');
                  await this.crudApi
                    .put(`/api/users/${this.user.get('_id')}`, {
                      blockUser: postUser,
                    })
                    .then(res => {
                      this.log('blocked User response: ', res);
                      this.tools.customToast('The user has been blocked');

                      this.user.info.blockedUsers =
                        _.get(res, 'data.blockedUsers') || [];
                      this.user.emit('hideShowContent');
                    })
                    .catch(e => {
                      this.tools.customToast('Could not block user');
                      this.log('blocked user failed: ', e);
                    });

                  opts.onBlockUser();
                },
              }
            : null,
          {
            icon: `<i class="fal fa-fw fa-pennant"></i>`,
            text: 'Flag Content',
            handler: event => {
              this.actionReportContent(content, collection, opts);
            },
          }
        );
      }
    }

    if (
      _.get(content, 'user._id') === this.user.get('_id') &&
      (content.source === 'COMMUNITY' || collection === 'engagements')
    ) {
      buttons.push(
        {
          icon: `<i class="fal fa-fw fa-fw fa-edit"></i>`,
          text: `Edit ${title}`,
          handler: () => {
            opts.onEdit();
          },
        },
        {
          icon: `<i class="fal fa-fw fa-trash"></i>`,
          text: `Delete ${title}`,
          handler: () => {
            this.actionDelete(content, collection, opts);
          },
        }
      );
    } else if (
      opts.isParentOwner &&
      collection === 'engagements' &&
      _.size(content.dimensions) > 0
    ) {
      buttons.push({
        icon: `<i class="fal fa-fw fa-trash-alt"></i>`,
        text: `Remove ${title}`,
        handler: () => {
          this.actionDelete(content, collection, opts, {
            subTitle: `Removing a comment will remove all the replies to that comment as well. This action cannot be undone.`,
            yes: 'Remove',
            yesCssClass: 'alert-button-confirmatory-red',
          });
        },
      });
    }

    // remove empties
    buttons = buttons.filter(d => d);

    await CmKit.ActionSheet({
      props: {
        buttons,
      },
    }).promise;
  }

  // Private internal action fns

  private async actionRemoveTag(content, collection, opts) {
    let tagToRemove = content.dimensions.filter(str => str.startsWith('HASH'));

    if (tagToRemove.length > 0) {
      //utilizing this route because it has a remove check if the value coming in already matches a value in dimensions
      await this.crudApi
        .post(`/api/${collection}/${content._id}/dimensions`, {
          value: tagToRemove[0],
        })
        .then(response => {
          opts.onCategorize(content.dimensions);
        });
    } else {
      this.log('No Hash Tag to Remove');
    }
  }

  private async actionReportContent(content, collection, opts) {
    opts = _.merge(opts, {
      userEngagements: {},
    });

    // not sure we want / need this?
    if (!opts.userEngagements.reported) {
      const res = await this.selectCategory(`What type of content is this?`, {
        hide: ['OTHER', 'NONE'],
      });

      if (!res) return;

      opts.userEngagements.reported = true;

      try {
        const d: any = {
          engagementType: 'REPORT',
          reportInformation: {
            category: res.key,
          },
        };

        if (collection === 'posts') {
          d.post = content._id;
        } else {
          d.post = _.get(content.post, '_id') || _.get(content, 'post');
          d.parentComment = content._id;
        }

        await this.crudApi.post('/api/engagements', d).then(response => {
          opts.onEngagement(response.data);
          opts.onReport(response.data);
          content.userEngagements.push(response.data);
        });
      } catch (e) {
        // dont care
      }
    }

    this.crudApi
      .post(`/api/users/${this.user.get('_id')}/hiddenPosts`, {
        value: content._id,
      })
      .catch(e => {})
      .then(res => {
        this.user.info.hiddenPosts = _.get(res, 'data.hiddenPosts') || [];
        opts.onReport();
      });

    CmKit.ActionSheet({
      props: {
        templates: {
          title: `
                <div style="text-align:center">
                  <div cm-font="Title / 20 Medium"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">
                       Thanks for Looking Out
                       </div>
                  <div cm-font="Body 16 / Regular"
                       class="cm-Margin--bottom"
                       cm-color="Neutral / Mine Shaft">
                       If you’d like, you can control what type of content shows up in your feed by updating some of your account settings.
                  </div>
                </div>
                `,
          button: button => {
            return `
                  <button class="cm-Button cm-Button--1 cm-Width-1-1"
                          cm-color="Primary / CDLLife Blue">
                  ${button.text}
                  </button>
                  `;
          },
          cancel: `
                <div style="text-align:center"
                      cm-font="Button / 14 Regular"
                      class="cm-Margin--bottom"
                      cm-color="Neutral / Manatee">
                  Dismiss
                </div>
                `,
        },
        buttons: [
          {
            text: 'Update Feed Settings',
            handler: () => {
              opts.navCtrl.push('FeedContentSettingsPage');
            },
          },
        ],
      },
    });
  }

  private async actionDelete(
    content,
    collection,
    opts,
    settings?: {
      title?: string;
      subTitle?: string;
      yes?: string;
      yesCssClass?: string;
    }
  ) {
    let alert = this.alertCtrl.create({
      title: (settings && settings.title) || 'Are you sure?',
      subTitle: (settings && settings.subTitle) || 'This cannot be undone.',
      buttons: [
        {
          text: 'Cancel',
          cssClass: 'alert-button-cancel',
          handler: () => {},
        },
        {
          text: (settings && settings.yes) || 'Yes',
          cssClass:
            (settings && settings.yesCssClass) || 'alert-button-confirmatory',
          handler: () => {
            _.set(content, 'states.isArchived', true);
            _.set(content, 'states.isBanned', true);
            this.crudApi
              .delete(
                `/api/${collection}/${content._id}?user=` +
                  _.get(content, 'user._id') || _.get(content, 'user')
              )
              .catch(e => {
                // this.log('error when deleting post', e);
              })
              .then(() => {
                opts.onDelete();
              });
          },
        },
      ],
      cssClass: 'alert-title',
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/content-tools/content-tools.ts